import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  Output,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-content-block-base',
  templateUrl: './content-block-base.component.html',
  styleUrls: ['./content-block-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockBaseComponent implements AfterViewInit, OnDestroy {
  private zone = inject(NgZone);

  @Input({ required: true }) block!: ContentBlock;
  @Input() index!: number;
  @Input() cookiePreferences!: CookiePreferences;

  @Input() set inviewPortTrigger(value: boolean) {
    this.inviewPort = value;

    if (this.standardScrollTrigger.length && !this.viewed) {
      this.standardScrollTrigger[0].refresh();
    }

    if (this.viewed) {
      return;
    }
    this.viewed = value;
  }

  viewed = false;
  inviewPort = false;

  standardScrollTrigger: globalThis.ScrollTrigger[] = [];
  fixedTheme: 'light' | 'dark' | undefined;
  private platformId = inject(PLATFORM_ID);

  @Output() themeChange = new EventEmitter<{ theme: string; enter: boolean }>();

  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    if (this.fixedTheme) {
      this.initScrollTrigger(`#blok-${this.index}`, this.fixedTheme);
    }
  }

  initScrollTrigger(className: string, theme: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.standardScrollTrigger.push(
          ScrollTrigger.create({
            trigger: className,
            start: 'top top',
            //end: `+=${elementHeight}`,
            //markers: true,
            onEnter: trigger => {
              this.themeChange.emit({ theme, enter: true });
            },
            onEnterBack: trigger => {
              this.themeChange.emit({ theme, enter: true });
            },
            onLeave: trigger => {
              this.themeChange.emit({ theme, enter: false });
            },
            onLeaveBack: trigger => {
              this.themeChange.emit({ theme, enter: false });
            },
          })
        );
      }, 2000);
    });
  }

  ngOnDestroy(): void {
    if (this.standardScrollTrigger) {
      this.standardScrollTrigger.forEach(trigger => {
        trigger.kill();
      });
    }
  }
}
